export type StaraGrade = 'A' | 'B' | 'C';

/**
 * Field ids used before the feedback fields moved into the sport configuration. Feedback submitted back then is
 * still read with them.
 */
const LEGACY_FIELD_IDS: Record<string, string> = {
  overallImpression: 'fb1',
  gymnastGreetings: 'fb2',
  coachGreetings: 'fb3',
};

export type StaraFeedbackTexts = Record<string, string>;

export type StaraCombinedPayload = {
  elements: Record<string, StaraGrade>;
  feedback: StaraFeedbackTexts;
};

export function isStaraGrade(value: unknown): value is StaraGrade {
  return value === 'A' || value === 'B' || value === 'C';
}

export function emptyFeedbackTexts(fieldIds: string[]): StaraFeedbackTexts {
  return Object.fromEntries(fieldIds.map((id) => [id, '']));
}

export function parseStaraCombined(raw: string | null, fieldIds: string[]): StaraCombinedPayload {
  const result: StaraCombinedPayload = { elements: {}, feedback: emptyFeedbackTexts(fieldIds) };
  if (!raw) {
    return result;
  }
  try {
    const parsed = JSON.parse(raw);
    if (parsed?.elements && typeof parsed.elements === 'object') {
      for (const [id, grade] of Object.entries(parsed.elements)) {
        if (isStaraGrade(grade)) {
          result.elements[id] = grade;
        }
      }
    }
    if (parsed?.feedback && typeof parsed.feedback === 'object') {
      for (const id of fieldIds) {
        result.feedback[id] = readText(parsed.feedback, id);
      }
    }
  } catch {
    return { elements: {}, feedback: emptyFeedbackTexts(fieldIds) };
  }
  return result;
}

function readText(feedback: Record<string, unknown>, id: string): string {
  const value = feedback[id] ?? feedback[LEGACY_FIELD_IDS[id]];
  return typeof value === 'string' ? value : '';
}
